import React, { useState, useRef, useEffect } from 'react';
import logo from '../assets/images/logo.png';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../Hooks';
import { useTranslation } from 'react-i18next';
import { i18n } from '../i18n';
import { useLocation } from 'react-router-dom';

type Props = {};

const Navbar: React.FC = (props: Props) => {
  const [activeLink, setActiveLink] = useState('');
  const { menu } = useAppSelector(state => state.menuAccess);
  const location = useLocation();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleLinkClick = (path: string) => {
    setActiveLink(path);
    setSidebarOpen(false);
  };
console.log(activeLink,'activeLink');

useEffect(() => {
  // Update `activeLink` whenever the current route changes
  setActiveLink(location.pathname);
}, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setActiveLink((prevActiveLink) =>
          ['/amenities', '/career', '/faq', '/gallery', '/language', '/more'].includes(prevActiveLink) ? '' : prevActiveLink
        );
        setIsDropdownOpen(false);
        setIsDropdownOpen2(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage("ar");
    localStorage.setItem('language', "ar");
    const linkElement = document.getElementById('dynamic-stylesheet') as any;
    if (linkElement) {
      linkElement.href = `/rtl.css`;
    }
  }, [i18n]);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    document.body.dir = lng === 'ar' ? 'rtl' : 'App';
    localStorage.setItem('language', lng);
    const linkElement = document.getElementById('dynamic-stylesheet') as any;
    setIsDropdownOpen(false);

    if (lng === 'ar') {
      if (linkElement) {
        linkElement.href = `/rtl.css`;
      }
    } else if (lng === 'en') {
      linkElement.href = `/App.css`;
    }
    setSidebarOpen(false);

  };

  useEffect(() => {
    const linkElement = document.getElementById('dynamic-stylesheet') as any;
    const savedLanguage = localStorage.getItem('language') || 'ar';
    i18n.changeLanguage(savedLanguage);
    document.body.dir = savedLanguage === 'ar' ? 'rtl' : 'App';
    if (savedLanguage === 'ar') {
      linkElement.href = `/rtl.css`;
    } else {
      linkElement.href = `/App.css`;
    }
  }, [i18n]);

  // Dropdown states
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);

    // Close "More" dropdown if it's open
    if (isDropdownOpen2) setIsDropdownOpen2(false);

    // Set active link to `/language` or reset if closing
    // setActiveLink(!isDropdownOpen ? '/language' : '');
  };

  const toggleDropdown2 = () => {
    setIsDropdownOpen2(!isDropdownOpen2);

    // Close "Language" dropdown if it's open
    if (isDropdownOpen) setIsDropdownOpen(false);

    // Set active link to `/more` or reset if closing
    setActiveLink(isDropdownOpen2 ? '/more' : '');

  };

  // Responsive sidebar navbar 
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg main-navbar bg-body-tertiary">
        <div className="container">
          <Link to="/" className="nav-box">
            <img src={logo} alt="logo" className='img-fluid' />
          </Link>
          <button className="navbar-toggler" onClick={toggleSidebar} type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
            <button className="close-button" onClick={toggleSidebar}>
              &times;
            </button>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item mx-2">
                <Link className={`nav-link ${activeLink === '/' ? 'active' : ''} ${menu && menu.home && menu.home.home ? '' : 'd-none'}`} to="/" onClick={() => handleLinkClick('/')}>
                  {t('navbar.home')}
                </Link>
              </li>
              <li className="nav-item mx-2">
                <Link className={`nav-link ${activeLink === '/about-us' ? 'active' : ''} ${menu && menu.about_us && menu.about_us.about_us ? '' : 'd-none'}`} to="/about-us" onClick={() => handleLinkClick('/about-us')}>
                  {t('navbar.about_us')}
                </Link>
              </li>
              <li className="nav-item mx-2">
                <Link className={`nav-link ${activeLink === '/room-suits' ? 'active' : ''} ${menu && menu.room_suits && menu.room_suits.room_suits ? '' : 'd-none'}`} to="/room-suits" onClick={() => handleLinkClick('/room-suits')}>
                  {t('navbar.room_suit')}
                </Link>
              </li>
              <li className="nav-item mx-2">
                <Link className={`nav-link ${activeLink === '/dinning' ? 'active' : ''} ${menu && menu.dinning && menu.dinning.dinning ? '' : 'd-none'}`} to="/dinning" onClick={() => handleLinkClick('/dinning')}>
                  {t('navbar.dinning')}
                </Link>
              </li>
              <li className="nav-item mx-2">
                <Link className={`nav-link ${activeLink === '/meetings-events' ? 'active' : ''} ${menu && menu.meeting_events && menu.meeting_events.meeting_events ? '' : 'd-none'}`} to="/meetings-events" onClick={() => handleLinkClick('/meetings-events')}>
                  {t('navbar.meeting')}
                </Link>
              </li>

              <li className="nav-item mx-2">
                <div className="dropdown">
                  <Link
                   className={`nav-link dropdown-toggle ${['/more', '/amenities', '/career', '/faq', '/gallery'].includes(activeLink) ? 'active' : ''}`}

                    to="#"
                    onClick={toggleDropdown2}
                    role="button"
                    aria-expanded={isDropdownOpen2}
                  >
                    {t('navbar.more')}
                  </Link>
                  <ul className={`dropdown-menu ${isDropdownOpen2 ? 'show' : ''}`}>
   
    <li onClick={()=>{setIsDropdownOpen2(false); setSidebarOpen(false) }}>
                      <Link className="dropdown-item" to="/amenities" >
                        {t('navbar.amenities')}
                      </Link>
                    </li>
                    <li onClick={()=>{setIsDropdownOpen2(false); setSidebarOpen(false) }}>
                      <Link className="dropdown-item" to="/career">
                        {t('navbar.career')}
                      </Link>
                    </li>
                    <li onClick={()=>{setIsDropdownOpen2(false); setSidebarOpen(false) }}>
                      <Link className="dropdown-item" to="/faq">
                        {t('navbar.faq')}
                      </Link>
                    </li>
                    <li onClick={()=>{setIsDropdownOpen2(false); setSidebarOpen(false) }}>
                      <Link className="dropdown-item" to="/gallery">
                        {t('navbar.gallery')}
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              <li className="nav-item mx-2">
                <Link className={`nav-link ${activeLink === '/blogs' ? 'active' : ''} ${menu && menu.blogs ? '' : 'd-none'}`} to="/blogs" onClick={() => handleLinkClick('/blogs')}>
                  {t('navbar.blogs')}
                </Link>
              </li>
              <li className="nav-item mx-2">
                <Link className={`nav-link ${activeLink === '/contact' ? 'active' : ''} ${menu && menu.contact ? '' : 'd-none'}`} to="/contact" onClick={() => handleLinkClick('/contact')}>
                  {t('navbar.contact')}
                </Link>
              </li>
              <li className="nav-item mx-2">
                <div className="dropdown">
                  <Link
                    className={`nav-link dropdown-toggle ${activeLink === '/language' ? 'active' : ''}`}
                    to="#"
                    onClick={toggleDropdown}
                    role="button"
                    aria-expanded={isDropdownOpen}
                  >
                    {t('navbar.language')}
                  </Link>
                  <ul className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                    <li>
                      <Link onClick={() => changeLanguage('ar')} className="dropdown-item" to="#">
                        Arabic
                      </Link>
                    </li>
                    <li>
                      <Link onClick={() => changeLanguage('en')} className="dropdown-item" to="#">
                        English
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
